import QueryString from 'qs';
import { useLocation } from 'react-router';

export function useQuery() {
  return QueryString.parse(useLocation().search, {
    ignoreQueryPrefix: true,
  });
}
